var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Calender"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calender",
    clipPath: "url(#clip-Calender)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "calendar_2_",
    "data-name": "calendar (2)",
    transform: "translate(0.224 0.229)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_19522",
    "data-name": "Path 19522",
    d: "M62.111,63.543H52.952l-.141-.034a1.351,1.351,0,0,1-1.054-1.345c0-1.226,0-2.452,0-3.675,0-1.407,0-2.811,0-4.218a1.323,1.323,0,0,1,1.057-1.336,4.5,4.5,0,0,1,.706-.04c.042,0,.085,0,.138,0V52h.9v.887h5.955V52h.9v.9c.195,0,.381-.006.571,0a1.345,1.345,0,0,1,1.054.545,1.552,1.552,0,0,1,.268.65v8.258a.731.731,0,0,0-.023.073,1.333,1.333,0,0,1-.938,1.059A2.446,2.446,0,0,1,62.111,63.543Zm-9.453-7.306V62.1c0,.373.17.542.545.542h8.662c.367,0,.54-.17.54-.534V56.238Zm0-.915H62.4c0-.373.006-.737,0-1.1a.424.424,0,0,0-.376-.415c-.2-.02-.4,0-.616,0v.89h-.9V53.8H54.551v.887h-.9v-.9h-.429c-.045,0-.09,0-.136,0a.442.442,0,0,0-.421.424C52.655,54.585,52.661,54.949,52.661,55.322Z",
    transform: "translate(-51.756 -52)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19524",
    "data-name": "Path 19524",
    d: "M120.2,239h-1.6v-1.6h1.6Z",
    transform: "translate(-116.712 -232.162)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19525",
    "data-name": "Path 19525",
    d: "M229.6,239H228v-1.6h1.6Z",
    transform: "translate(-223.021 -232.162)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19526",
    "data-name": "Path 19526",
    d: "M339,239h-1.6v-1.6H339Z",
    transform: "translate(-329.33 -232.162)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19527",
    "data-name": "Path 19527",
    d: "M120.2,338h-1.6v-1.6h1.6Z",
    transform: "translate(-116.712 -328.365)",
    fill: "#0071cd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19528",
    "data-name": "Path 19528",
    d: "M229.6,338H228v-1.6h1.6Z",
    transform: "translate(-223.021 -328.365)",
    fill: "#0071cd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderIcon);
export default __webpack_public_path__ + "static/media/CalenderIcon.3e991352aff1183a9ecdc7deb805b374.svg";
export { ForwardRef as ReactComponent };